import { IconButton } from '@/components/Buttons/IconButton';
import { Spinner } from "@/components/Loader/Spinner";
import { ThemePressable } from '@/components/Theme/ThemePressable';
import { ThemeText } from '@/components/Theme/ThemeText';
import { View } from '@/components/Theme/View';
import { useLoaderBackground } from '@/hooks/useLoaderBackground';
import { useStyleResolver } from './useStyleResolver';

const hasPressableProps = ({disabled, onPress, loading}) => {
    if (disabled)
        return {};

    let _props = {};

    if (onPress) {
        _props.onPress = !loading ? onPress : undefined;
    }

    return _props;
}

export const BaseButton = (props) => {

    const {
        children = null,
        title = null,
        titleProps = {},
        options = [],
        onPress = () => {},
        size: _size = 'sm',
        style = {},
        variant = null,
        textStyle = {},
        leftIcon = null,
        rightIcon = null,
        subtitle = null,
        iconSize = null,
        loading = false,
        iconRowStyle = null,
        light = null,
        iconColor:forceIconColor = null,
        dark = null,
        borderLess = false,
        disabled = false,
        ...rest
    } = props;

    const { 
        textProps,
        iconColor,
        pressStyle,
        newColors,
        iconRow
    } = useStyleResolver({
        size: _size,
        variant,
        style,
        disabled,
        textStyle,
        iconRowStyle,
        colors: {
            light: light,
            dark: dark
        }
    });

    const { backgroundColor } = useLoaderBackground();

    const ifChildren = children 
        ? children 
        : title != null  
            ?   <View>
                    <ThemeText variant={['xxs']} {...textProps} selectable={false} id={title} options={options} {...titleProps} />
                    {typeof subtitle === 'string' && subtitle.length > 0 &&
                        <ThemeText variant={['small']} {...textProps} selectable={false} id={subtitle} options={options} />
                    }
                </View>
        : null;
    
    const pressableProps = hasPressableProps({ onPress, loading, disabled });
    
    return (
        <ThemePressable 
            {...pressableProps}
            style={pressStyle}
            light={newColors?.light}
            dark={newColors?.dark}
            pressType='button'
            variant={variant} 
            disabled={disabled}
            {...rest} 
            flex={rest?.flex}
        >
            {loading &&
                <View bgColor={backgroundColor} zIndex={50} position="absolute" left={0} right={0} top={0} bottom={0} alignItems="center" justifyContent="center">
                    <Spinner bold size={17} color={{light: 'muted.1000', dark: 'muted.50'}} />
                </View>   
            }

            {(leftIcon || rightIcon) 
            ? (
                <View style={iconRow}>
                    {leftIcon && <IconButton icon={leftIcon} size={iconSize ?? 16} color={forceIconColor ?? iconColor} />}
                    {ifChildren}
                    {rightIcon && <IconButton icon={rightIcon} size={iconSize ?? 16} color={forceIconColor ?? iconColor} />}
                </View>
            ) 
            : ifChildren}
        </ThemePressable>
    );
};